import * as React from 'react';

import Linkify from 'linkify-react';

interface Props {
  children: React.ReactNode;
}

export const renderLink = ({
  attributes,
  content,
}: {
  attributes: { key: string; href: string };
  content: string;
}) => {
  return (
    <a
      key={attributes.key}
      href={attributes.href}
      className="linkable-textarea-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      {content}
    </a>
  );
};

export const LinkableTextArea = ({ children }: Props): any => {
  if (typeof children === 'string') {
    return (
      <Linkify
        options={{
          render: renderLink as any,
        }}
      >
        {children}
      </Linkify>
    );
  }
  return children;
};
